import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http'; 
import { HttpModule } from '@angular/http';
import { tap } from 'rxjs/operators/tap';
import { IAdditionalNotesLineItemDetail, IDetailLineItem, IDetailType, IFecalLineItemDetail, IFeedingLineItemDetail, IFoodSize, IFoodType, 
	     IGrowthLineItemDetail, IHealthLineItemDetail, IInventoryMasterDetail, IShedLineItemDetail,IFeedingOutcome, IShedType, 
	     IHealthIncidentType, IFecalAppearance,IFeedingType, IViewDetailLineItem, IViewMasterDetailWithImage } from '../interfaces/index';
import { AdditionalNotesLineItemDetail, DetailLineItem, DetailType, FecalLineItemDetail, FeedingLineItemDetail, FoodSize, FoodType, GrowthLineItemDetail, HealthLineItemDetail, InventoryMasterDetail, ShedLineItemDetail } from '../models/index';

const url = "http://api.reptilebin.com/api/Detail/";
//const url = "http://localhost:53148/api/Detail/";
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin':'*',
		'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE',
		'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
	})
};

@Injectable()
export class DetailsService {

  	constructor(public http: HttpClient) {}

  	getMasterDetailRecords(groupId: number):Observable<IInventoryMasterDetail[]>{
  		return this.http.post<IInventoryMasterDetail[]>(url+"GetMasterDetails", groupId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getDetailTypes():Observable<IDetailType[]>{
		return this.http.get<IDetailType[]>(url+"GetDetailTypes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getDetailLineItems(inventoryId: number):Observable<IDetailLineItem[]>{
		return this.http.post<IDetailLineItem[]>(url+"GetDetailLineItems", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFecalLineItemDetails(inventoryId: number):Observable<IFecalLineItemDetail[]>{
		return this.http.post<IFecalLineItemDetail[]>(url+"GetFecalLineItemDetails", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFeedingLineItemDetails(inventoryId: number):Observable<IFeedingLineItemDetail[]>{
		//console.log('Test');
		return this.http.post<IFeedingLineItemDetail[]>(url+"GetFeedingLineItemDetails", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFoodSizes():Observable<IFoodSize[]>{
		return this.http.get<IFoodSize[]>(url+"GetFoodSizes", httpOptions).pipe(
			tap(resp => {
				//console.log(resp);
				return resp;
		}));
	}

	getFoodTypes():Observable<IFoodType[]>{
		return this.http.get<IFoodType[]>(url+"GetFoodTypes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getGrowthLineItemDetails(inventoryId: number):Observable<IGrowthLineItemDetail[]>{
		return this.http.post<IGrowthLineItemDetail[]>(url+"GetGrowthLineItemDetails", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getHealthLineItemDetails(inventoryId: number):Observable<IHealthLineItemDetail[]>{
		return this.http.post<IHealthLineItemDetail[]>(url+"GetHealthLineItemDetails", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getShedLineItemDetails(inventoryId: number):Observable<IShedLineItemDetail[]>{
		return this.http.post<IShedLineItemDetail[]>(url+"GetShedLineItemDetails", inventoryId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFeedingOutcomes():Observable<IFeedingOutcome[]>{
		return this.http.get<IFeedingOutcome[]>(url+"GetFeedingOutcomes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFeedingTypes():Observable<IFeedingType[]>{
		return this.http.get<IFeedingType[]>(url+"GetFeedingTypes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getShedTypes():Observable<IShedType[]>{
		return this.http.get<IShedType[]>(url+"GetShedTypes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getHealthIncidentTypes():Observable<IHealthIncidentType[]>{
		return this.http.get<IHealthIncidentType[]>(url+"GetHealthIncidentTypes", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getDefecationAppearances():Observable<IFecalAppearance[]>{
		return this.http.get<IFecalAppearance[]>(url+"GetDefecationAppearances", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	createLineItemDetailRecord(detailRecord: IViewDetailLineItem):Observable<boolean>{
  		//console.log(groupId);
		return this.http.post<boolean>(url+"CreateLineItemDetailRecord", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getLatestGrowthLineItemDetail(detailRecord: IViewDetailLineItem):Observable<IGrowthLineItemDetail>{
		return this.http.post<IGrowthLineItemDetail>(url+"GetLatestGrowthLineItemDetail", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getLatestShedLineItemDetail(detailRecord: IViewDetailLineItem):Observable<IShedLineItemDetail>{
		return this.http.post<IShedLineItemDetail>(url+"GetLatestShedLineItemDetail", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getLatestFecalLineItemDetail(detailRecord: IViewDetailLineItem):Observable<IFecalLineItemDetail>{
		return this.http.post<IFecalLineItemDetail>(url+"GetLatestFecalLineItemDetail", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getLatestHealthLineItemDetail(detailRecord: IViewDetailLineItem):Observable<IHealthLineItemDetail>{
		return this.http.post<IHealthLineItemDetail>(url+"GetLatestHealthLineItemDetail", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getLatestFeedLineItemDetail(detailRecord: IViewDetailLineItem):Observable<IFeedingLineItemDetail>{
		return this.http.post<IFeedingLineItemDetail>(url+"GetLatestFeedLineItemDetail", detailRecord, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	createMasterDetailRecord(detail: IViewMasterDetailWithImage):Observable<IInventoryMasterDetail>{
		return this.http.post<IInventoryMasterDetail>(url+"CreateMasterDetail", detail, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	deleteMasterDetailRecord(detail: IViewMasterDetailWithImage):Observable<IInventoryMasterDetail>{
		return this.http.post<IInventoryMasterDetail>(url+"DeleteMasterDetailRecord", detail, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	updateMasterDetailRecord(detail: IViewMasterDetailWithImage):Observable<IInventoryMasterDetail>{
		console.log(detail);
		return this.http.post<IInventoryMasterDetail>(url+"UpdateMasterDetail", detail, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getMasterDetailRecordById(masterId: number):Observable<IInventoryMasterDetail>{
  		return this.http.post<IInventoryMasterDetail>(url+"GetMasterDetailRecord", masterId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getFoodTypesByInventoryType(inventoryTypeId: number):Observable<IFoodType[]>{
  		return this.http.post<IFoodType[]>(url+"GetFoodTypesByInventoryType", inventoryTypeId, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/details.service.ts